import React from 'react';

import { intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import { propTypes } from '../../util/types';

import { isTaxLineItem, extractTaxPercentage } from './LineItemTaxWithheldMaybe';
import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

/**
 * Renders "Tax withheld" deduction in provider breakdown after subtotal.
 * Tax is includeFor:['customer'] only, so we read from allLineItems.
 * This is a display-only deduction — the actual payout reduction is handled
 * by Sharetribe (tax not in provider's includeFor means it's not in payoutTotal).
 *
 * @component
 * @param {Object} props
 * @param {Array} props.allLineItems - All unfiltered transaction line items
 * @param {boolean} props.isProvider
 * @param {intlShape} props.intl
 */
const LineItemTaxWithheldDeductionMaybe = props => {
    const { allLineItems, isProvider, intl } = props;

    if (!isProvider) return null;

    const taxLineItems = (allLineItems || []).filter(
        item => isTaxLineItem(item) && !item.reversal
    );

    if (taxLineItems.length === 0) return null;

    return (
        <>
            {taxLineItems.map((item, i) => {
                const percentage = extractTaxPercentage(item.code);
                const percentageLabel = percentage != null ? ` (${percentage}%)` : '';
                const negativeAmount =
                    item.lineTotal instanceof Money
                        ? new Money(-Math.abs(item.lineTotal.amount), item.lineTotal.currency)
                        : null;
                const formattedWithheld = negativeAmount ? formatMoney(intl, negativeAmount) : null;

                return (
                    <div key={`tax-withheld-${i}`} className={css.lineItem}>
                        <span className={css.itemLabel}>{`Tax withheld${percentageLabel}`}</span>
                        <span className={css.itemValue}>{formattedWithheld}</span>
                    </div>
                );
            })}
        </>
    );
};

export default LineItemTaxWithheldDeductionMaybe;
